import { Icon, Tooltip } from "@amzn/storm-ui";
import { Text } from "@amzn/storm-ui";
import { infoCircle } from "@amzn/storm-ui-icons";
import * as React from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";

interface LabelEndComponentProps {
    tooltip?: string;
    optional?: boolean;
}

const InlineGap = styled.span`
    margin: 0 6px;
    display: inline-flex;
    gap: 6px;
    align-items: center;
    font-size: 13px;
    font-family: "Amazon Ember", Helvetica, sans-serif;
    padding: 0px;
    color: rgb(35, 47, 63);
    font-weight: 400;
`;

export const LabelEndComponent: React.FunctionComponent<
    LabelEndComponentProps
> = (props) => {
    const { tooltip, optional } = props;

    return (
        <InlineGap>
            {tooltip && (
                <Tooltip
                    disablePortal
                    withCloseButton={false}
                    trigger={
                        <Icon
                            role="button"
                            type={infoCircle}
                            size="small"
                            style={{ color: "grey" }}
                        />
                    }
                >
                    <ReactMarkdown linkTarget="_blank">{tooltip}</ReactMarkdown>
                </Tooltip>
            )}
            {optional && (
                <Text renderAs="span" size="xsmall" color="secondary">
                    Optional
                </Text>
            )}
        </InlineGap>
    );
};
